var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 612,
    viewBox: "0 0 151 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_37865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.402 393.324L129.33 396.826L125.074 416.975L120.818 396.826L101.693 393.27L120.711 388.637L125.074 369.619L129.384 388.637L148.402 393.324Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3663 479.093L67.6992 481.086L65.2748 492.346L62.9044 481.086L52.2373 479.093L62.8505 476.507L65.2748 465.894L67.6992 476.507L78.3663 479.093Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.442 163.661L125.775 165.654L123.351 176.86L120.98 165.654L110.313 163.661L120.926 161.075L123.351 150.408L125.775 161.075L136.442 163.661Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9377 377.11C36.1865 377.209 35.4969 377.578 34.9974 378.148C34.4978 378.718 34.2224 379.45 34.2224 380.207C34.2224 380.965 34.4978 381.697 34.9974 382.267C35.4969 382.837 36.1865 383.206 36.9377 383.305C37.689 383.206 38.3786 382.837 38.8781 382.267C39.3776 381.697 39.653 380.965 39.653 380.207C39.653 379.45 39.3776 378.718 38.8781 378.148C38.3786 377.578 37.689 377.209 36.9377 377.11Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86491 227.393C1.34511 227.475 0.871713 227.739 0.529814 228.14C0.187915 228.54 0 229.049 0 229.575C0 230.101 0.187915 230.61 0.529814 231.01C0.871713 231.41 1.34511 231.675 1.86491 231.757C2.38471 231.675 2.85819 231.41 3.20009 231.01C3.54199 230.61 3.72991 230.101 3.72991 229.575C3.72991 229.049 3.54199 228.54 3.20009 228.14C2.85819 227.739 2.38471 227.475 1.86491 227.393Z",
    fill: "#FFC727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_37865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 610.792,
    fill: "white",
    transform: "translate(0 0.662537)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsMobile);
export default __webpack_public_path__ + "static/media/stars-mobile.c0a57b5b6996a5da23da6a7d651df01d.svg";
export { ForwardRef as ReactComponent };